import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: 'Extra {{percentageAmount}}% reducere',
  [OfferKindEnum.PercentageOffByProducts]: 'Extra {{percentageAmount}}% reducere',
  [OfferKindEnum.AmountOffByProducts]: 'Extra {{amount}} reducere',
  [OfferKindEnum.Bogo]: '2 LA 1',
  [OfferKindEnum.BogoHalfPrice]: 'Cumpără 1, primești 1 la jumătate de preț!',
  [OfferKindEnum.FreeItemByProducts]: 'Produs gratuit',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Produs gratuit',
};

export default OfferBadge;
